import { StorageKeys } from '@/utils/constants';
import type {
  InspectionInsightPreferences,
  InspectionInsightScope,
} from '@/types';

const STORAGE_KEY = `${StorageKeys.SearchInspections}-insights`;

const DEFAULT_PREFS: InspectionInsightPreferences = {
  expanded: false,
  scope: 'allSite',
  chartPeriodDays: 28,
};

export const loadInsightPreferences = (): InspectionInsightPreferences => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_PREFS;
    const parsed = JSON.parse(raw) as Partial<InspectionInsightPreferences>;
    return {
      expanded: !!parsed.expanded,
      scope: parsed.scope === 'currentResults' ? 'currentResults' : 'allSite',
      chartPeriodDays:
        parsed.chartPeriodDays === 7 || parsed.chartPeriodDays === 90
          ? parsed.chartPeriodDays
          : 28,
    };
  } catch {
    return DEFAULT_PREFS;
  }
};

export const saveInsightPreferences = (prefs: InspectionInsightPreferences) => {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
};

export const isInsightScope = (
  value: string,
): value is InspectionInsightScope =>
  value === 'allSite' || value === 'currentResults';
